import { ResetPasswordModel } from './../_models/resetPasswordModel';
import { ForgetPasswordModel } from './../_models/forgetPasswordModel';
import { RegisterUserModel } from './../_models/registerUserModel';
import { Injectable, Inject, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { User } from "../_models/user.model";
import { Permission } from "../_models/permission.model";
import { catchError, map, tap } from "rxjs/operators";
import { QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { Credentials } from "../_models/credentials";
import { Store, select } from '@ngrx/store';
import { isLoggedIn } from '../_selectors/auth.selectors';
import { AppState } from '../../reducers';
import { CommonService } from '../../../modules/management/shared/services/common.service';
import { UserLoaded } from '../_actions/auth.actions';
import { promise } from 'protractor';


const LOGIN_URL = "Auth/accounts/web/Login";
const GET_CURRENT = "Auth/accounts/web/GetCurrentUser";
const API_PERMISSION_URL = "Auth/permission/getuserpermissions/";
const API_ROLES_URL = "api/roles";
const REGISTER_USER = 'Auth/accounts/Register';
const FORGET_PASSWORD = 'Auth/accounts/forgotpassword';
const RESET_PASSWORD = 'Auth/accounts/resetMobilePassword';

@Injectable()
export class AuthService {
  apiEndpoint: string;
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private commonService: CommonService
  ) {


  }


  // Authentication/Authorization
  login(mobile: string, password: string): Observable<any> {
    const authData: Credentials = {
      Username: mobile,
      Password: password,
      Grant_Type: "password",
      Client_Id: "ngAuthApp"
    };
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${LOGIN_URL}`, authData)
  }
  registerUser(model: RegisterUserModel) {
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${REGISTER_USER}`, model);
  }
  forgetPassword(model: ForgetPasswordModel) {
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${FORGET_PASSWORD}`, model);
  }
  resetPassword(model: ResetPasswordModel) {
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${RESET_PASSWORD}`, model);
  }
  getUserByToken(): Observable<User> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    const headerss = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + userToken
    })
    return this.http.get<User>(`${this.commonService.getApiEndpoint()}/${LOGIN_URL}`, { headers: headerss });
  }

  register(user: User): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.post<User>(LOGIN_URL, user, { headers: httpHeaders }).pipe(
      map((res: User) => {
        return res;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  /*
   * Submit forgot password request
   *
   * @param {string} email
   * @returns {Observable<any>}
   */
  public requestPassword(email: string): Observable<any> {
    return this.http
      .get(LOGIN_URL + "/forgot?=" + email)
      .pipe(catchError(this.handleError("forgot-password", [])));
  }

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(LOGIN_URL);
  }

  getUserById(userId: number): Observable<User> {
    return this.http.get<User>(LOGIN_URL + `/${userId}`);
  }

  // DELETE => delete the user from the server
  deleteUser(userId: number) {
    const url = `${LOGIN_URL}/${userId}`;
    return this.http.delete(url);
  }

  // UPDATE => PUT: update the user on the server
  updateUser(_user: User): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.put(LOGIN_URL, _user, { headers: httpHeaders });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: User): Observable<User> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.post<User>(LOGIN_URL, user, { headers: httpHeaders });
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.post<QueryResultsModel>(
      LOGIN_URL + "/findUsers",
      queryParams,
      { headers: httpHeaders }
    );
  }

  // Permission
  getAllPermissions() {
    var res: Permission[] = [];
    return res;
    // let headers = new HttpHeaders();
    // headers.append('Authorization', `Bearer ${localStorage.getItem(environment.authTokenKey)}`);
    // return this.http.get(`${this.commonService.getApiEndpoint()}/${API_PERMISSION_URL}`, { headers: headers });
  }

  getRolePermissions(roleId: number): Observable<Permission[]> {
    return this.http.get<Permission[]>(
      API_PERMISSION_URL + "/getRolePermission?=" + roleId
    );
  }








  // Check Role Before deletion
  isRoleAssignedToUsers(roleId: number): Observable<boolean> {
    return this.http.get<boolean>(
      API_ROLES_URL + "/checkIsRollAssignedToUser?roleId=" + roleId
    );
  }

  findRoles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // This code imitates server calls
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.post<QueryResultsModel>(
      API_ROLES_URL + "/findRoles",
      queryParams,
      { headers: httpHeaders }
    );
  }

  /*
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = "operation", result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }

  isLoggedIn() {
    return this.store
      .pipe(
        select(isLoggedIn),
        tap(loggedIn => {
          return loggedIn;
        })
      );
  }

  reloadUser() {
    this.getUserByToken().subscribe(res => {
      if (res) {
        const _user: User = new User();
        _user.firstName = res["result"]["firstName"];
        _user.lastName = res["result"]["lastName"];
        _user.isMale = res["result"]["isMale"];
        _user.username = res["result"]["username"];
        _user.role = res["result"]["role"];
        _user.userStatus = res["result"]["userStatus"];
        _user.isBeta = res["result"]["isBeta"];
        _user.walletBalance = res["result"]["walletBalance"];
        _user.userAffiliateStatus = res["result"]["userAffiliateStatus"];
        this.store.dispatch(new UserLoaded({ user: _user }));
      }
    });
  }



}
